import React from "react";
import { Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";

import { TimeDiff } from "components/common/Time";
import culturehqbot from "images/badges/culturehqbot.png";
import getUserName from "app/utils/getUserName";

const FeedItemUser = ({ user }) => {
  if (user) {
    return (
      <ProfileLink user={user} aria-label={getUserName(user)}>
        <Thumbnail className="Thumbnail" image={user.avatar.thumbUrl} title={getUserName(user)} />
      </ProfileLink>
    );
  }

  return <Thumbnail className="Thumbnail" image={culturehqbot} title="CultureBot" />;
};

const FeedItemTitle = ({ item, date, children, user }) => (
  <div className="FeedItem__preview__header">
    <div className="FeedItem__user">
      <FeedItemUser user={user || (item?.users && item.users[0])} />
    </div>
    <div className="FeedItem__preview__header__info">
      {children}
      <p className="FeedItem__preview__header__date">
        <TimeDiff time={date} format="%B %e at %l:%M %p" />
      </p>
    </div>
  </div>
);

export default FeedItemTitle;
